import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/ui-bits";
import { Field } from "@/pages/Login";

export default function AdminSettings() {
  const [s, setS] = useState({
    usdt_wallet: "", hourly_reward_rate: 0.0001375, max_roi_multiplier: 2.0,
    reward_funding_deduction_pct: 0.5, min_withdraw: 20, network: "BEP20",
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/settings/public").then(({ data }) => setS((p) => ({ ...p, ...data }))); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings", {
        usdt_wallet: s.usdt_wallet,
        hourly_reward_rate: Number(s.hourly_reward_rate),
        max_roi_multiplier: Number(s.max_roi_multiplier),
        min_withdraw: Number(s.min_withdraw),
        network: s.network || "BEP20",
      });
      toast.success("Settings saved");
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  const set = (k, v) => setS({ ...s, [k]: v });
  const hourlyPct = (Number(s.hourly_reward_rate || 0) * 100).toFixed(5);

  return (
    <div>
      <PageHeader title="System Settings" subtitle="Deposit wallet & program parameters" />
      <div className="glass p-6 max-w-2xl space-y-4">
        <Field label="USDT Deposit Wallet (BEP20)" value={s.usdt_wallet || ""} onChange={(v) => set("usdt_wallet", v)} testid="settings-wallet" />
        <div className="grid grid-cols-2 gap-4">
          <Field label={`Hourly Reward Rate (currently ${hourlyPct}%)`} type="number" value={s.hourly_reward_rate} onChange={(v) => set("hourly_reward_rate", v)} testid="settings-rate" />
          <Field label="Max Reward Multiplier (e.g. 2 = 2×)" type="number" value={s.max_roi_multiplier} onChange={(v) => set("max_roi_multiplier", v)} testid="settings-multiplier" />
          <Field label="Min Withdraw ($)" type="number" value={s.min_withdraw} onChange={(v) => set("min_withdraw", v)} testid="settings-min" />
          <Field label="Network" value={s.network || "BEP20"} onChange={(v) => set("network", v)} testid="settings-network" />
        </div>
        <div className="text-xs text-[#94A3B8] border-t border-white/5 pt-3">
          Reward → funding deduction is fixed at {((s.reward_funding_deduction_pct ?? 0.5) * 100).toFixed(0)}% of each reward withdrawal.
        </div>
        <button onClick={save} disabled={busy} data-testid="settings-save"
                className="px-6 py-2.5 bg-[#00F0FF] text-[#060B19] font-bold rounded-lg hover:bg-[#00D4E0] disabled:opacity-50">
          {busy ? "Saving…" : "Save Settings"}
        </button>
      </div>
    </div>
  );
}
